import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { StaffStoreState } from 'modules/staff/store/StaffStoreState';

export const useStaffSelector: TypedUseSelectorHook<StaffStoreState> =
  useSelector;
